/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Stack } from '@mui/material'

const linkStyle = css`
  display: flex;
  align-items: center;
  font-size: 12px;
  &:link {
    color: #6f6f6f;
    text-decoration: none;
  }
  &:visited {
    color: #6f6f6f;
    text-decoration: none;
  }
  &:hover {
    color: #00f932;
    text-decoration: none;
  }
`

const Footer = () => {
  return (
    <Stack alignItems="center" justifyContent="center" height="250px">
      <a
        href={`https://www.instagram.com/openstudio.info`}
        css={linkStyle}
        target="blank"
      >
        All rights reserved. OpenStudio_2022
      </a>
    </Stack>
  )
}

export default Footer
